<!-- shopping-cart-table.component.html -->
<table
  style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">

  <thead>
    <tr>
      <th style="text-align: left; border-bottom: 1px solid #ccc;">Item</th>
      <th style="text-align: left; border-bottom: 1px solid #ccc;">Price</th>
      <th style="text-align: right; border-bottom: 1px solid #ccc;">Total</th>
      @if (displayStatus) {
        <th style="text-align: right; border-bottom: 1px solid #ccc;">Approval</th>
      }

      @if (displayRemovalButtons) {
        <th style="text-align: center; border-bottom: 1px solid #ccc;"></th>
      }
    </tr>
  </thead>

  <tbody>
    @for (offer of sortedOffers; track offer) {
      <tr>
        <td style="text-align: left;" class="item-name-cell">
          <div
            class="item-name-wrap"
            (mouseenter)="tooltipService.openItemNamePopover(offer)"
            (mouseleave)="tooltipService.closeItemNamePopover(offer)">
            <button
              #itemNameTrigger
              type="button"
              class="item-name-trigger"
              [attr.aria-expanded]="tooltipService.isItemNamePopoverOpen(offer)"
              aria-haspopup="dialog"
              [attr.aria-label]="tooltipService.getUpgradeItemName(offer)"
              (click)="tooltipService.toggleItemNamePopover($event, offer, itemNameTrigger, isHandset)"
              (focus)="tooltipService.openItemNamePopover(offer, itemNameTrigger, isHandset)"
              (blur)="tooltipService.closeItemNamePopover(offer)">
              {{ tooltipService.getUpgradeItemName(offer) | titlecase }}
            </button>

            @if (tooltipService.isItemNamePopoverOpen(offer) && tooltipService.getUpgradeItemName(offer)) {
              <div
                class="item-name-popover"
                role="tooltip"
                [style.left.px]="tooltipService.itemNamePopoverLeft"
                [style.top.px]="tooltipService.itemNamePopoverTop"
                [style.max-width.px]="tooltipService.itemNamePopoverMaxWidth">
                {{ tooltipService.getUpgradeItemName(offer) | titlecase }}
              </div>
            }
          </div>
        </td>
        <td style="text-align: left;">{{ getOfferDetails(offer) }}</td>
        <td style="text-align: right;">{{ calculatePrice(offer) | currency:'USD' }}</td>
        @if (displayStatus) {
          <td style="text-align: right;">
            @if (offer.upgrade_status===this.OfferStatus.ACCEPTED) {
              <div class="status-accepted">{{offer.upgrade_status | titlecase}}</div>
            }
            @if (offer.upgrade_status===this.OfferStatus.PENDING) {
              <div class="status-pending">{{offer.upgrade_status | titlecase}}  </div>
            }
            @if (offer.upgrade_status===this.OfferStatus.REJECTED) {
              <div class="status-rejected">Declined</div>
            }
          </td>
        }
        @if (displayRemovalButtons) {
          <td style="text-align: center;">
            <span
              style="background-color: transparent !important;"
              (click)="removeOfferFromCart(offer, offerAliasId)"
              class="remove-button">
              <i class="fas fa-trash"></i>
            </span>
          </td>
        }
      </tr>
    }
    <tr>
      <td style="text-align: left;">Tax</td>
      <td></td>
      <td style="text-align: right;">{{ calculateTotalTaxes(offers) | currency:'USD' }}</td>
      @if (displayStatus) {
        <td></td>
      }
      @if (displayRemovalButtons) {
        <td></td>
      }
    </tr>
    <tr style="font-weight: bold; border-top: 2px solid #ccc;">
      <td style="text-align: left;">Total</td>
      <td></td>
      <td style="text-align: right;">{{ calculateTotalWithTaxes(offers) | currency:'USD' }}</td>
      @if (displayStatus) {
        <td></td>
      }
      @if (displayRemovalButtons) {
        <td></td>
      }
    </tr>
  </tbody>
</table>
